import { Avatar, Button, Flex, Text } from '@applyboard/crystal-ui'
import styled from '@emotion/styled'
import { useContext } from 'react'
import { MenuOutlineIcon } from '@applyboard/ui-icons'
import { useGetAgent, useLoggedInUser } from '../../hooks'
import { up } from '../../utils'
import { ConfigContext } from '../../utils/ConfigProvider'

type HeaderProps = {
  desktopSidebarChange: () => void
  mobileSidebarChange: () => void
}

export function Header(props: Readonly<HeaderProps>) {
  const { username } = useLoggedInUser()
  const { isLoadingAgent, agent } = useGetAgent({ id: username })
  const { ui, school } = useContext(ConfigContext)
  const headerLogoUrl = ui?.headerLogo?.['138x36']
  const schoolName = school?.name ?? ''

  return (
    <HeaderWrapper>
      <Flex justify="between" align="center" p={2} gap={2}>
        <Flex align="center" grow={{ xs: 1, sm: 0 }} gap={4}>
          <Flex hideBelow="sm">
            <Button
              onClick={props.desktopSidebarChange}
              aria-label="Main Menu"
              leadIcon={MenuOutlineIcon}
              intent="primary"
            />
          </Flex>
          {schoolName || headerLogoUrl ? <SchoolLogo schoolName={schoolName} headerLogoUrl={headerLogoUrl} /> : null}
        </Flex>
        <Flex hideAbove="sm">
          <Button
            onClick={props.mobileSidebarChange}
            aria-label="Main Menu"
            leadIcon={MenuOutlineIcon}
            intent="primary"
          />
        </Flex>
        <Flex hideBelow="sm">
          {!isLoadingAgent ? (
            <Avatar
              alt={
                agent ? `${agent.attributes.profile.givenName} ${agent.attributes.profile.familyName}` : ''
              }
              size="sm"
              initials={
                !agent?.attributes?.profile?.givenName
                  ? 'ME'
                  : `${agent?.attributes.profile.givenName?.[0] ?? ''}${
                      agent?.attributes.profile.familyName?.[0] ?? ''
                    }`.toUpperCase()
              }
            />
          ) : null}
        </Flex>
      </Flex>
    </HeaderWrapper>
  )
}

const HeaderWrapper = styled.div(({ theme }) => ({
  backgroundColor: theme.colors.actionPrimary,
  zIndex: 1720,
  "button[aria-label='Main Menu']": {
    outlineColor: theme.colors.bgRegular,
  },
  [up('sm')]: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
  },
}))

type SchoolLogoProps = {
  schoolName: string
  headerLogoUrl?: string
}

function SchoolLogo(props: Readonly<SchoolLogoProps>) {
  if (!props.headerLogoUrl) {
    return (
      <Text contrast="inverted" variant="bodyL">
        {props.schoolName}
      </Text>
    )
  }

  return <img alt={props.schoolName} src={props.headerLogoUrl} />
}
